import { Injectable } from "@angular/core";
import { AzureAnalyticsDto, AzureCategoryType, AzurePlatformType, AzureProductTrackingEvent, AzureStatusCodes } from "projects/assets/model/azure";
import { environment } from "projects/marketplace/src/environments/environment";
import { ConfigService } from "./config.service";

@Injectable({ providedIn: 'root' })

export class AzureApiService {
    public cdnUrl: string;
    constructor(private configService: ConfigService) {
    }

    async postProductDetailAnalytics(eventname: AzureProductTrackingEvent, productAttrGuid: string, startDate: Date, endDate: Date, inviteGuid: string = '', errorMessage: string = '', statusCodes: AzureStatusCodes = AzureStatusCodes.Ok, categoryType: AzureCategoryType = null, productGuid: string = '', productName: string = '', capacityType: string = '', capacityValue: string = null) {
        let data: AzureAnalyticsDto = new AzureAnalyticsDto();
        data.productAttrGuid = productAttrGuid;
        data.eventName = eventname;
        data.inviteGuid = inviteGuid;
        data.errorMessage = errorMessage;
        data.type = AzurePlatformType.MarketPlace;
        data.statusCodes = statusCodes;
        data.rewardType = categoryType;
        data.productGuid = productGuid;
        data.productName = productName;
        data.capacityType = capacityType;
        data.capacityValue = capacityValue;

        try {
            data.eventStartTimeUtc = startDate ? startDate.toISOString() : "";
            data.eventEndTimeUtc = endDate ? endDate.toISOString() : "";
        }
        catch {
            data.eventStartTimeUtc = "";
            data.eventEndTimeUtc = "";
        }
        this.postUserAnalyticsOfProduct(data);
    }

    async postLocationAnalytics(locationData: any) {
        let data = { LocationData: locationData, PlatformType: AzurePlatformType.MarketPlace };
        this.postUserAnalyticsOfLocation(data);
    }

    private postUserAnalyticsOfProduct(params) {
        if (environment.production) {
            return this.configService?.post('api/user/analytics', params, null, null, null, null, environment.azureFunctionUrl)?.subscribe();
        }
    }

    private postUserAnalyticsOfLocation(params) {
        if (environment.production) {
            return this.configService?.post('api/user/location/analytics', params, null, null, null, null, environment.azureFunctionUrl)?.subscribe();
        }
    }
}